interface StepLabelProps {
  label: string
}

const StepLabel: React.FC<StepLabelProps> = ({ label }) => {
  return <label dangerouslySetInnerHTML={{ __html: label }} className="step-label" />;
}

export default StepLabel;
